import React, { Component, Fragment } from 'react';
import ComplementSignetRowHistory from './ComplementSignetRowHistory';
import { Row, Col, Card, Table } from 'react-bootstrap';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import SearchFilter from '../../Reusable/SearchFilter';
import withTranslations from '../../../utils/HighOrderComponent';

class ComplementSignetTableHistory extends Component {
  render() {
    const { t, enums } = this.props || {},
      { HeaderColumns, Labels } = t || {},
      { titleTable } = Labels || {};

    const complementSignetList = this.props.complementSignetList?.map(
      (complementSignet, index) => (
        <ComplementSignetRowHistory
          index={index + 1}
          key={complementSignet.id}
          complementSignet={complementSignet}
          enums={enums}
        />
      )
    );

    const table = (
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Row>
                <Col className="col-md-8">
                  <Card.Title as="h3">{titleTable}</Card.Title>
                </Col>
                <Col className="col-md-3">
                  <SearchFilter noSearchColums={0} signal={true} />
                </Col>
              </Row>
            </Card.Header>

            <Table responsive hover id="filterTable">
              <thead>
                <tr className="text-center">
                  <th className="align-top" width="4%">
                    #
                  </th>
                  <th className="align-top" width="70%">
                    {HeaderColumns.description}
                  </th>
                  <th className="align-top">{HeaderColumns.creator}</th>
                  <th className="align-top">{HeaderColumns.createdAt}</th>
                </tr>
              </thead>
              <tbody>{complementSignetList}</tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    );

    return <Fragment>{table}</Fragment>;
  }
}

export default withTranslations(
  ComplementSignetTableHistory,
  'ComplementSignetTableHistory'
);
